import React from 'react';
import { useWhiteboardStore } from '../../../store/useWhiteboardStore';
import { getGlassClasses } from '../../../utils/glassStyles';
import { useTheme } from '../../../hooks/useDarkMode';

interface OpticalPanelToggleButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const OpticalPanelToggleButton: React.FC<OpticalPanelToggleButtonProps> = ({
  isOpen,
  onClick
}) => {
  const { glassEffects, devicePreferences } = useWhiteboardStore();
  const { isDark } = useTheme();
  
  return (
    <button
      onClick={onClick}
      className={`absolute top-20 w-10 h-10 rounded-lg flex items-center justify-center cursor-pointer z-[1001] shadow-lg transition-all duration-300 ${
        glassEffects !== false 
          ? getGlassClasses(devicePreferences?.preferences?.glassColor || 'crystal', isDark)
          : 'bg-white border border-gray-200 hover:bg-gray-50'
      } ${isOpen ? 'right-[304px]' : 'right-4'}`}
      title={isOpen ? 'Optik Formu Kapat' : 'Optik Formu Aç'}
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 20 20" 
        fill="none"
        className={`transition-transform duration-300 ${
          isOpen ? 'rotate-180' : ''
        } ${isDark ? 'text-gray-300' : 'text-gray-600'}`}
      >
        <path 
          d="M12.5 5L7.5 10L12.5 15" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};